import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { LEAD_STATUS } from "../../config/constants";

const STAGES = [
  {
    key: LEAD_STATUS.NEW,
    label: "A qualifier",
    description: "Premiers contacts a initier",
    palette: { backgroundColor: "rgba(37,99,235,0.16)", color: "#1d4ed8" },
    link: `/leads?status=${LEAD_STATUS.NEW}`,
  },
  {
    key: LEAD_STATUS.CONTACTED,
    label: "Contactes",
    description: "Premiers echanges realises",
    palette: { backgroundColor: "rgba(79,70,229,0.16)", color: "#4338ca" },
    link: `/leads?status=${LEAD_STATUS.CONTACTED}`,
  },
  {
    key: LEAD_STATUS.QUALIFIED,
    label: "Qualifies",
    description: "Opportunites validees",
    palette: { backgroundColor: "rgba(6,182,212,0.16)", color: "#0e7490" },
    link: `/leads?status=${LEAD_STATUS.QUALIFIED}`,
  },
  {
    key: LEAD_STATUS.NEGOTIATION,
    label: "Negociation",
    description: "Decisions en attente",
    palette: { backgroundColor: "rgba(247,144,9,0.16)", color: "#b45309" },
    link: `/leads?status=${LEAD_STATUS.NEGOTIATION}`,
  },
  {
    key: LEAD_STATUS.CONVERTED,
    label: "Convertis",
    description: "Dossiers remportes",
    palette: { backgroundColor: "rgba(16,185,129,0.16)", color: "#047857" },
    link: `/leads?status=${LEAD_STATUS.CONVERTED}`,
  },
];

const LeadPipeline = ({ counts = {}, total = 0 }) => {
  const displayTotal =
    total || Object.values(counts).reduce((acc, val) => acc + (val || 0), 0);

  return (
    <section className="panel-surface p-6">
      <header className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-lg font-semibold text-[var(--color-text-primary)]">
            Pipeline prospects
          </h2>
          <p className="text-sm text-[var(--color-text-muted)]">
            {displayTotal} prospects répartis sur l'ensemble du cycle
            commercial.
          </p>
        </div>
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-[var(--color-brand-soft)] text-[var(--color-brand)]">
          <Sparkles className="w-4 h-4" /> Vue synthèse
        </span>
      </header>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-5">
        {STAGES.map((stage) => {
          const value = counts[stage.key] || 0;
          const progress = displayTotal
            ? Math.min(100, (value / displayTotal) * 100)
            : 0;
          return (
            <Link
              key={stage.key}
              to={stage.link}
              className="panel-quiet p-4 hover:shadow-soft-lg transition-all duration-200"
            >
              <div className="flex items-center justify-between">
                <span
                  className="inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full"
                  style={stage.palette}
                >
                  {stage.label}
                </span>
                <ArrowUpRight className="w-4 h-4 text-[var(--color-text-muted)]" />
              </div>
              <p className="mt-4 text-2xl font-semibold text-[var(--color-text-primary)]">
                {value}
              </p>
              <p className="text-xs text-[var(--color-text-muted)]">
                {stage.description}
              </p>
              <div className="mt-4 h-2 rounded-full bg-[var(--color-bg-surface)] overflow-hidden">
                <div
                  className="h-full rounded-full bg-[var(--color-brand)]/75"
                  style={{ width: `${progress}%` }}
                />
              </div>
              <p className="mt-2 text-xs font-medium text-[var(--color-text-secondary)]">
                {progress.toFixed(0)}% du portefeuille
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default LeadPipeline;
